import React, { PropsWithChildren, createContext, useContext, useMemo } from 'react';

type ArtboardLayoutContextValue = {
  sectionId: string;
  currentArtboardLayoutId: string;
};

const ArtboardLayoutContext = createContext<ArtboardLayoutContextValue>({
  sectionId: '',
  currentArtboardLayoutId: '',
});

export const useArtboardLayoutContext = (): ArtboardLayoutContextValue => {
  return useContext(ArtboardLayoutContext);
};

type ArtboardLayoutContextProviderProps = PropsWithChildren<{
  sectionId: string;
  currentArtboardLayoutId: string;
}>;

export const ArtboardLayoutContextProvider: React.FC<ArtboardLayoutContextProviderProps> = (props) => {
  const { sectionId, currentArtboardLayoutId, children } = props;
  const value = useMemo(() => ({ sectionId, currentArtboardLayoutId }), [sectionId, currentArtboardLayoutId]);

  return (
    <ArtboardLayoutContext.Provider value={value}>
      {children}
    </ArtboardLayoutContext.Provider>
  );
};
